import { Form } from "antd";
import { CrudForm, CrudFormItemProps, CrudFormWrapperProps, nameof } from "digimuth-components/dist";
import { EndForgotPasswordDto } from "../../../api";
import styles from './forgotPasswordComplete.module.less';
import { useState } from "react";
import CheckPasswordComponent from "./subComponents/checkPasswordComponent";
import CheckConfirmPasswordComponent from "./subComponents/checkConfirmPasswordComponent";

const layout = {
    labelCol: {span: 24},
    wrapperCol: {span: 24},
    layout: 'vertical',
    requiredMark: false
};

const tailLayout = {
    wrapperCol: {span: 24},
};

export default function ForgotPasswordComplete(props: CrudFormWrapperProps<EndForgotPasswordDto>) {
    const [passwordIsValid, setPasswordIsValid] = useState(false);
    const [passwordsAreEqual, setPasswordsAreEqual] = useState(false);
    const [form] = Form.useForm();

    const formItems: CrudFormItemProps[] = [{
        label: "Nowe hasło",
        name: "password",
        children: <CheckPasswordComponent onPasswordCheck={setPasswordIsValid} />
    }, {
        label: "Potwierdź hasło",
        name: nameof<EndForgotPasswordDto>("newPassword"),
        dependencies: ["password"],
        children: <CheckConfirmPasswordComponent form={form} onPasswordCheck={setPasswordsAreEqual} />
    }];

    return <CrudForm
        isSubmitDisabled={!passwordIsValid || !passwordsAreEqual}
        form={form}
        onSubmit={props.onSubmit}
        formItems={formItems}
        saveButtonTitle="Ustaw nowe hasło"
        formProps={layout}
        tailProps={tailLayout}
        submitButtonProps={{ className: styles.submitButton }}
    />;
}
